























import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import type { ChatParticipant, Conversation } from '../types';
import { ConversationType } from '../types';
import { ChatHelper } from '../helpers';

export default defineComponent({
  props: {
    conversation: {
      type: Object as PropType<Conversation>,
      default: () => ({}),
    },
    participants: {
      type: Array as PropType<ChatParticipant[]>,
      default: () => [],
    },
  },
  setup(props) {
    const filteredParticipants = computed(() =>
      ChatHelper.getConversationParticipants(props.participants, props.conversation.participants)
    );

    return {
      filteredParticipants,
      ConversationType,
      getParticipantsDetails: ChatHelper.getParticipantsDetails,
    };
  },
});
